import { i18nHelper } from "@tweddle-se-team/common/helpers";
import {
  initLocale,
  initLocalizations,
} from "@/utils/apiHelpers/i18nApiHelper";
import { i18nL10nActions } from "@/store/i18nL10n";
const { setLocale } = i18nHelper;

const initialLocaleState = (store) => async (language) => {
  let locale = null;
  // If language is provided, set locale based on it
  if (language) {
    locale = setLocale(language);
  }
  // If not provided or not a valid language, initialize locale based on browser settings
  if (!locale) locale = initLocale();
  store.dispatch(i18nL10nActions.SET_LOCALE(locale));
};

/**
 * Loads localization data on the server side
 * @param {*} store Redux store.
 */
const getDictionary = async (store) => {
  const { i18nL10n } = store.getState();
  if (!Object.keys(i18nL10n?.dictionary).length) {
    const dict = await initLocalizations();
    store.dispatch(i18nL10nActions.SET_DICTIONARY(dict));
    return dict;
  }
  return i18nL10n.dictionary;
};

const localizationHelpers = {
  initialLocaleState,
  getDictionary,
};

export default localizationHelpers;
